import React, {useEffect, useState} from "react";
import {Instant} from "@js-joda/core";
import {formatDuration} from "../../../utils/time-utils";

export const TimeDiff = ({time}: { time: Date }) => {
    const [diffSec, setDiffSec] = useState(Instant.now().epochSecond() - (time.getTime() / 1000))

    useEffect(() => {
        const interval = setInterval(() => {
            setDiffSec((difSec) => difSec + 1)
        }, 1000)
        return () => {
            clearInterval(interval)
        }
    }, [])

    useEffect(()=>{
        setDiffSec(Instant.now().epochSecond() - (time.getTime() / 1000))
    },[time])

    return <>{formatDuration(diffSec)}</>
}